export const environment = {
    production: false,
    agencyMecklenburg: 1,
    agencyRockRegion: 2,
    apiUrl: 'https://eligibility-api-dev.ecolane.com/',
    TTAuth: 'https://authservice-preprod.transit-technologies.ai',
    firebase : {
      apiKey: "AIzaSyA_Ik1ZvO3jzo6lAxZrhAqwrj-4SMVhfbk",
      authDomain: "eligibility-module.firebaseapp.com",
      projectId: "eligibility-module",
      storageBucket: "eligibility-module.firebasestorage.app",
      messagingSenderId: "713057314295",
      appId: "1:713057314295:web:2e56d6f72b3d75aeec7af2",
      measurementId: "G-33MW8B4WR6",
      vapidKey : "BKGVC2pfSx6LgT3MblqyO0ylZvJfhPXXHv-Xkb8RlJoHgyZyNuiMLX9cCuM-hWBwz_0Gag6m8v_vxt5cefYjt2c"
    }
};
